import SKButton from 'components/UI/SKButton';
import classes from './styles.module.scss';
import { useRouter } from 'next/router';
import { DOWNLOAD_PAGE } from 'constants/route.const';
import clsx from 'clsx';

const DownloadBtn = ({ isSikka, link, title, isPro, color }) => {
  const router = useRouter();

  return (
    <div className={classes.btnWrap}>
      {isSikka ? (
        <SKButton
          className={clsx(!color && classes.defaultColor, classes.blogBtn)}
          isLink
          gradient={false}
          target={'_blank'}
          rel="noreferrer noopener nofollow"
          href="https://play.google.com/store/apps/details?id=com.sikka.freemoney&utm_source=sikkaweb&utm_medium=websikka&utm_campaign=sikkaweborganic"
        >
          Download Sikka
        </SKButton>
      ) : (
        <SKButton
          className={clsx(!color && classes.defaultColor, classes.blogBtn)}
          isLink
          gradient={false}
          target={'_blank'}
          rel="noreferrer noopener nofollow"
          href={link}
          bgColor={color}
        >
          {title}
        </SKButton>
      )}
    </div>
  );
};

export default DownloadBtn;
